import { render, staticRenderFns } from "./RaffleWinnersTable.vue?vue&type=template&id=decf4f14&"
import script from "./RaffleWinnersTable.vue?vue&type=script&lang=ts&"
export * from "./RaffleWinnersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports